import { render, staticRenderFns } from "./record-cp-filter.vue?vue&type=template&id=36c50024&scoped=true"
import script from "./record-cp-filter.vue?vue&type=script&lang=js"
export * from "./record-cp-filter.vue?vue&type=script&lang=js"
import style0 from "./record-cp-filter.vue?vue&type=style&index=0&id=36c50024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c50024",
  null
  
)

export default component.exports